var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAracdeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6364 6.90909V5H11.3636V6.90909H9.45455C6.99437 6.90909 5 8.90345 5 11.3636V17.0137C5 18.1107 5.8893 19 6.98629 19C7.51309 19 8.01832 18.7908 8.39082 18.4182L10.9909 15.8182H13.0091L15.6092 18.4182C15.9817 18.7908 16.4869 19 17.0137 19C18.1107 19 19 18.1107 19 17.0137V11.3636C19 8.90345 17.0056 6.90909 14.5455 6.90909H12.6364ZM17.7273 11.3636C17.7273 9.60637 16.3028 8.18182 14.5455 8.18182H9.45455C7.69727 8.18182 6.27273 9.60637 6.27273 11.3636V17.0137C6.27273 17.4078 6.5922 17.7273 6.98629 17.7273C7.17554 17.7273 7.35704 17.6521 7.49086 17.5183L10.4636 14.5455H13.5364L16.5091 17.5183C16.643 17.6521 16.8245 17.7273 17.0137 17.7273C17.4078 17.7273 17.7273 17.4078 17.7273 17.0137V11.3636ZM7.54545 12.6364V11.3636H8.81818V10.0909H10.0909V11.3636H11.3636V12.6364H10.0909V13.9091H8.81818V12.6364H7.54545ZM14.5455 11.0455C14.5455 11.5726 14.1181 12 13.5909 12C13.0637 12 12.6364 11.5726 12.6364 11.0455C12.6364 10.5183 13.0637 10.0909 13.5909 10.0909C14.1181 10.0909 14.5455 10.5183 14.5455 11.0455ZM15.5 13.9091C16.0272 13.9091 16.4545 13.4817 16.4545 12.9545C16.4545 12.4274 16.0272 12 15.5 12C14.9728 12 14.5455 12.4274 14.5455 12.9545C14.5455 13.4817 14.9728 13.9091 15.5 13.9091Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAracdeWhite);
export default __webpack_public_path__ + "static/media/aracde-white.20ee79b0c67d2e8764191692460e80e2.svg";
export { ForwardRef as ReactComponent };